import styled, { css } from 'styled-components';
import { defaultCreatedTheme, Utils } from '@hiro-ui/bootstrap';

export interface StyledListItemProps {
  active?: boolean;
  childIsOpen?: boolean;
}

export const StyledListItem = styled.li<StyledListItemProps>`
  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.greyscale.light};
    `}

  ${({ childIsOpen, active }) =>
    (childIsOpen || active) &&
    css`
      color: ${({ theme }) => theme.colors.primary.default};
      font-weight: bold;

      & > i {
        color: ${({ theme }) => theme.colors.primary.default};
      }
    `}
`;

export const SidebarWrapper = styled.div`
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;

  & > ul {
    border-right: 1px solid ${({ theme }) => theme.greyscale.medium};
    width: 276px;
    box-sizing: border-box;

    ${Utils.sm} {
      display: none;
    }
  }

  main.scrolled & > ul {
    position: fixed;
    top: 30px;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
  }

  & ul {
    list-style: none;
    margin: 0;
    padding-left: 20px;
  }

  & li {
    user-select: none;
    padding: 0.5em 20px 0.5em 0.5em;

    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.greyscale.light};
    }
  }
`;

SidebarWrapper.defaultProps = {
  theme: defaultCreatedTheme,
};
